/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { fileModelSchema } from "./fileModelSchema.ts";
import { z } from "zod";

export const radioStateModelSchema = z.object({
    "hasStarted": z.boolean().describe("Запущено ли радио"),
"radioScheduled": z.boolean().describe("Радио запланировано"),
"url": z.string().describe("URL потока"),
"dateStarted": z.string().datetime({ offset: true }).describe("Дата начала").nullable().nullish(),
"dateEnd": z.string().datetime({ offset: true }).describe("Дата окончания эфира").nullable().nullish(),
"sendNotificationTimeInMinutes": z.number().int().describe("За сколько минут до начала эфира отправлять уведомление").nullable().nullish(),
"timerInSeconds": z.number().int(),
"trackFrequency": z.number().int().describe("Число треков в чистой волне"),
"podcastFrequency": z.number().int().describe("Число подкастов в чистой волне"),
"needToSendNotification": z.boolean().describe("Нужно ли отправлять уведомления о прямом эфире"),
"picture": z.lazy(() => fileModelSchema)
    })